import { type DwellSectionKey , useDwellTiming } from './DwellTiming';
import { type BoxRef , Box } from '../../../mads';
import { useTrackVisibility } from '../../../shared/logging/visibility-tracker';

import React, { type PropsWithChildren, useEffect, useRef } from 'react';

type DwellTrackedSectionProps = PropsWithChildren<{
    section: DwellSectionKey;
}>;

export function DwellTrackedSection({ section, children }: DwellTrackedSectionProps) {
    const wrapperRef = useRef<BoxRef>(null);
    const isVisibleRef = useRef(false);
    const { setSectionVisibility } = useDwellTiming();

    useTrackVisibility(wrapperRef, {
        once: false,
        onVisibilityChange: ({ isVisible }) => {
            if (isVisibleRef.current === isVisible) {
                return;
            }

            isVisibleRef.current = isVisible;
            setSectionVisibility(section, isVisible);
        },
    });

    useEffect(() => {
        return () => {
            if (isVisibleRef.current) {
                isVisibleRef.current = false;
                setSectionVisibility(section, false);
            }
        };
    }, [section, setSectionVisibility]);

    return <Box ref={wrapperRef}>{children}</Box>;
}
